// Access-token storage — the single source of truth for the JWT.
//
// Plain module (no React) so both the auth layer (AuthContext) and the API
// layer (api-client) can share it without one depending on the other. The
// token lives in localStorage; callers read it at request time, so there's
// never a stale in-memory copy to keep in sync.

const TOKEN_KEY = 'firex_access_token'

export function saveToken(token: string) { localStorage.setItem(TOKEN_KEY, token) }
export function loadToken(): string | null { return localStorage.getItem(TOKEN_KEY) }
export function clearToken() { localStorage.removeItem(TOKEN_KEY) }

/** Authorization header for the current token, or `{}` when logged out. */
export function getAuthHeader(): Record<string, string> {
  const token = loadToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

// Dispatched on `window` by the API layer whenever a request comes back 401, so
// the auth layer can end the session without the API client importing React or
// router state. AuthProvider listens for it and calls logout().
export const AUTH_UNAUTHORIZED_EVENT = 'auth:unauthorized'
